<script>
    import Popover from '../_common/popover.svelte'
    import ObFinish from './ob-finish.svelte'
    import ObPosPayment from './ob-pos-payment.svelte'
    import ObPosServices from './ob-pos-services.svelte'
    import ObReferral from './ob-referral.svelte'
    import ObScheduler from './ob-scheduler.svelte'
    import ObStart from './ob-start.svelte'
    import ObSubscription from './ob-subscription.svelte'
    import ObUsers from './ob-users.svelte'

    let step = 0
    let total = 7
    let percent = 0
    let last = ''

    $: {
        percent = parseInt((step / total) * 100)
        if (percent > 100) percent = 100
    }

    function onboardingClose() {}

    function goBack() {
        last = 'back'
        if (step > 0) step -= 1
    }

    function goNext() {
        last = 'next'
        step += 1
    }

    function goIgnore() {
        if (last === 'back') {
            goBack()
            return
        }
        if (last === 'next') {
            goNext()
        }
    }
</script>

<Popover
    close={false}
    on:close={onboardingClose}
    title="OnBoarding - Configuração rápida e fácil"
    width="1180px"
    height="80vh"
>
    <div class="root">
        <div class="progress">
            <div
                class="progress-bar progress-bar-striped bg-dark"
                role="progressbar"
                style="width: {percent}%;"
                aria-valuenow={step}
                aria-valuemin="0"
                aria-valuemax={total}
            >
                {percent}%
            </div>
        </div>

        <div class="root-in">
            {#if step === 0}
                <ObStart on:next={goNext} />
            {/if}
            {#if step === 1}
                <ObSubscription on:ignore={goIgnore} on:back={goBack} on:next={goNext}></ObSubscription>
            {/if}
            {#if step === 2}
                <ObScheduler on:back={goBack} on:next={goNext} />
            {/if}
            {#if step === 3}
                <ObUsers on:back={goBack} on:next={goNext} />
            {/if}
            {#if step === 4}
                <ObPosPayment on:back={goBack} on:next={goNext} />
            {/if}
            {#if step === 5}
                <ObPosServices on:back={goBack} on:next={goNext} />
            {/if}
            {#if step === 6}
                <ObReferral on:back={goBack} on:next={goNext} />
            {/if}
            {#if step === 7}
                <ObFinish on:back={goBack} />
            {/if}
        </div>
    </div>
</Popover>

<style>
    .root {
        display: flex;
        flex-direction: column;
        height: 100%;
        flex-grow: 1;
    }
    .root-in {
        flex-grow: 1;
        display: flex;
    }
    .progress {
        background-color: #444;
        border-radius: 0px;
    }
</style>
